import { useDispatch } from 'react-redux';
import { formActions } from 'store/vaxFormDataSlice';
import { vaxEditDataActions } from 'store/vaxEditDataSlice.js';
import { useDeleteFileMutation } from 'api/glob.api';
import { useDeleteFileInternalMutation } from 'api/internal.api.ts';

const useRemoveFile = (internal) => {
	const dispatch = useDispatch();
	const [deleteFile] = useDeleteFileMutation();
	const [deleteFileInternal] = useDeleteFileInternalMutation();

	const removeFile = (file) => {
		dispatch(formActions.removeFile(file));
		dispatch(vaxEditDataActions.removeFile(file));
		if (internal) {
			deleteFileInternal(file);
		} else {
			deleteFile(file);
		}
	};
	return removeFile;
};

export default useRemoveFile;
